function launchPopup(url: string) {
  window.open(url, '_blank', 'width=1024,height=700')
}

export function launchTraceEventDetailView(eventKey: string | number | undefined) {
  launchPopup(import.meta.env.BASE_URL + `index.html?event=${eventKey}`)
}

export function traceEventPageViewLink(
  viewType: 'primary' | 'namedPage',
  eventKey?: string | number,
  pageName?: string
): string {
  return (
    import.meta.env.BASE_URL +
    `index.html?event=${eventKey}&viewType=${viewType}${pageName ? `&pageName=${pageName}` : ''}`
  )
}

export function launchTraceEventPageView(
  viewType: 'primary' | 'namedPage',
  eventKey: string | number | undefined,
  pageName?: string
) {
  launchPopup(traceEventPageViewLink(viewType, eventKey, pageName))
}

export function traceEventPropertiesViewLink(viewType: 'parameters' | 'variables', eventKey: number | undefined) {
  return import.meta.env.BASE_URL + `index.html?event=${eventKey}&viewType=${viewType}`
}

export function launchTraceEventPropertiesView(viewType: 'parameters' | 'variables', eventKey: number | undefined) {
  launchPopup(traceEventPropertiesViewLink(viewType, eventKey))
}
